import React from 'react'
import PropTypes from 'prop-types'
import DropZone from '../DropZone'

const UploadImage = ({ isUploaded }) => {
  return (
    <div>
      <h2 className="text-[#F67443] text-[30px] text-center mb-4 font-semibold">Upload Images</h2>
      <DropZone type="images" isUploaded={isUploaded} />
    </div>
  )
}
UploadImage.propTypes = {
  isUploaded: PropTypes.bool,
}
export default React.memo(UploadImage)
